
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ParticlesComponent from './components/particles';
import GridCards from './components/card/gridCards';


function App() {
  return (
    <>
      <div>
        <ParticlesComponent />
        <GridCards />
      </div>
    </>
  );
}


export default App;
